import { render, staticRenderFns } from "./EsTabs.vue?vue&type=template&id=41a2d9a0&scoped=true&"
import script from "./EsTabs.vue?vue&type=script&lang=js&"
export * from "./EsTabs.vue?vue&type=script&lang=js&"
import style0 from "./EsTabs.vue?vue&type=style&index=0&id=41a2d9a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a2d9a0",
  null
  
)

export default component.exports